import { withRouter } from 'helpers/withRouter'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

import './Nav.scss'

const navItemClassNames = (classBase, currentStepPosition, step, numSteps) => {
  let classes = [classBase]

  if (step.position === 0) {
    classes.push(`${classBase}--is-first`)
  }

  if (currentStepPosition === step.position) {
    classes.push(`${classBase}--is-current`)
  }

  if (step.position < currentStepPosition) {
    classes.push(`${classBase}--is-done`)
  }

  if (step.position === numSteps - 1) {
    classes.push(`${classBase}--is-last`)
  }

  return classes.join(' ')
}

export const Nav = ({
  t,
  steps,
  currentLocale,
  currentStepPosition,
  slug,
  projectTitle,
  unskippable,
  router: { location },
}) => {
  const searchParams = useSearchParams()[0]
  const branch = searchParams.get('branch') || ''

  return (
    <div className="c-project-navigation">
      <input
        className="c-project-navigation__toggle-checkbox"
        id="c-project-navigation__toggle-checkbox"
        type="checkbox"
      />

      <label
        className="c-project-navigation__toggle-label"
        htmlFor="c-project-navigation__toggle-checkbox"
      >
        {t('project.nav.label')}
        <span className="c-project-navigation__toggle-icon" />
      </label>

      <ul className="c-project-navigation__list">
        {steps.map((step, index) => {
          if (unskippable && currentStepPosition < step.position) {
            return (
              <li className="c-project-navigation__item" key={index}>
                <span
                  className={navItemClassNames(
                    'c-project-navigation__step',
                    currentStepPosition,
                    step,
                    steps.length
                  )}
                >
                  {step.title}
                </span>
              </li>
            )
          }
          const linkTo = `/${currentLocale}/projects/${slug}/${step.position}${
            branch ? `?branch=${branch}` : ''
          }`
          return (
            <li className="c-project-navigation__item" key={index}>
              <Link
                className={navItemClassNames(
                  'c-project-navigation__link',
                  currentStepPosition,
                  step,
                  steps.length
                )}
                to={linkTo}
                state={{ prevPath: location.pathname }}
                data-on="click"
                data-event-category={projectTitle}
                data-event-action="Clicked Navigation Link"
                role="link"
                tabIndex={0}
              >
                {step.title}
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

Nav.propTypes = {
  t: PropTypes.func.isRequired,
  steps: PropTypes.array.isRequired,
  currentLocale: PropTypes.string.isRequired,
  currentStepPosition: PropTypes.number.isRequired,
  projectTitle: PropTypes.string.isRequired,
  unskippable: PropTypes.bool.isRequired,
  router: PropTypes.shape({
    location: PropTypes.object.isRequired,
  }).isRequired,
  slug: PropTypes.string.isRequired,
}

export default withTranslation('translations')(withRouter(Nav))
